export const PALETTE = {
  WHITE: '#ffffff',
  BLACK: '#1a1a1a',
  YELLOW: '#F8D748',
  LIGHT_GRAY: '#E6E6E6',
  GRAY: '#DCDCDC',
  DARK_BLUE: '#010030',
} as const;